import { RootState } from "@/redux/store";

export const configSelector = (state: RootState) => state.config.config;
export const siteInfoSelector = (state: RootState) => state.config.siteInfo;
export const kindeConfigSelector = (state: RootState) => state.config.kindeConfig;
// Per-domain reCAPTCHA site key (guest booking pairs it with the backend's verifying secret). Undefined on older backends.
export const recaptchaSiteKeySelector = (state: RootState) => state.config.config?.recaptcha_site_key;
